// Change Password Modal - Shown when user must change password after login

import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './MasterData/MasterData.css';

interface ChangePasswordModalProps {
  onClose?: () => void;
}

export function ChangePasswordModal({ onClose }: ChangePasswordModalProps) {
  const { changePassword } = useAuth();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!currentPassword) {
      setError('Bitte geben Sie Ihr aktuelles Passwort ein.');
      return;
    }

    if (newPassword.length < 8) {
      setError('Das neue Passwort muss mindestens 8 Zeichen lang sein.');
      return;
    }

    if (!/[A-Z]/.test(newPassword) || !/[a-z]/.test(newPassword) || !/[0-9]/.test(newPassword) || !/[^A-Za-z0-9]/.test(newPassword)) {
      setError('Das Passwort muss Groß- und Kleinbuchstaben, eine Ziffer und ein Sonderzeichen enthalten.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('Die Passwörter stimmen nicht überein.');
      return;
    }

    if (newPassword === currentPassword) {
      setError('Das neue Passwort muss sich vom alten Passwort unterscheiden.');
      return;
    }

    try {
      setLoading(true);
      await changePassword(currentPassword, newPassword);
      if (onClose) onClose();
    } catch (err: any) {
      const msg = err.response?.data?.message || err.message || 'Fehler beim Ändern des Passworts';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" style={{ zIndex: 10000 }}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h3>Passwort ändern erforderlich</h3>
        <p style={{ color: '#666', marginBottom: '16px' }}>
          Ihr Passwort wurde zurückgesetzt. Bitte geben Sie Ihr aktuelles (temporäres) Passwort und ein neues Passwort ein.
        </p>

        {error && (
          <div className="error-message" style={{ marginBottom: '16px' }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Aktuelles Passwort *</label>
            <input
              type="password"
              name="current-password"
              autoComplete="current-password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              placeholder="Ihr aktuelles / temporäres Passwort"
              required
              autoFocus
            />
          </div>

          <div className="form-group">
            <label>Neues Passwort *</label>
            <input
              type="password"
              name="new-password"
              autoComplete="new-password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Mind. 8 Zeichen, Groß/Klein, Ziffer, Sonderzeichen"
              minLength={8}
              required
            />
          </div>

          <div className="form-group">
            <label>Neues Passwort bestätigen *</label>
            <input
              type="password"
              name="confirm-password"
              autoComplete="new-password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Passwort wiederholen"
              minLength={8}
              required
            />
          </div>

          <div className="modal-actions">
            <button
              type="submit"
              className="btn-primary"
              disabled={loading || !currentPassword || newPassword.length < 8 || confirmPassword.length < 8}
            >
              {loading ? 'Wird gespeichert...' : 'Passwort ändern'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
